import { render } from "./UserTasksEdit.vue?vue&type=template&id=2a635ea1&scoped=true"
import script from "./UserTasksEdit.vue?vue&type=script&lang=js"
export * from "./UserTasksEdit.vue?vue&type=script&lang=js"

import "./UserTasksEdit.vue?vue&type=style&index=0&id=2a635ea1&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2a635ea1"

export default script